import React from 'react'
import { useField } from 'formik'
import MuiPhoneNumber from 'material-ui-phone-number'

const FormikPhoneInput = ({ label, ...props }) => {
  const [field, meta] = useField(props)

  return (
    <>
      <MuiPhoneNumber
        {...field}
        {...props}
        variant="outlined"
        margin="normal"
        fullWidth
        autoFocus
        label={label}
        error={meta.touched && meta.error ? true : false}
        helperText={meta.touched && meta.error ? meta.error : null}
      />
    </>
  )
}

export default FormikPhoneInput
